import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, { page: number; searchKey: string; search: string }>({
    query: (body) => ({
      url: `v4/pitch-owner/users/search?page=${body.page}`,
      method: 'POST',
      body: {
        [body.searchKey]: body.search,
      },
    }),
  });

export interface SearchedUser {
  id: number;
  image: string;
  name: string;
  phone: number;
}
